import { createSelector } from "reselect"

const selectTeeupsState = state => state.teeupsState

export const selectTeeupsStateTeeups = createSelector(
  selectTeeupsState,
  teeupState => teeupState.teeups || {}
)
